import type { City } from "@/apis/city/city-apis";
import { strings } from "@/I18n";
import { parseCityId } from "@/utils/filters";
import { Button } from "@/v2/ui/primitives/button";
import { WHITELABEL_LABELS } from "../constants";

interface PreviewModeBannerProps {
  previewRole: string;
  previewWhitelabel: string | null;
  savedCity: string | null;
  citiesList: City[];
  onExit: () => void;
}

export function PreviewModeBanner({
  previewRole,
  previewWhitelabel,
  savedCity,
  citiesList,
  onExit,
}: PreviewModeBannerProps) {
  let previewCityName: string | null = null;
  if (previewRole === "city_admin" && savedCity) {
    const cityIdParsed = parseCityId(savedCity);
    const city = citiesList?.find((c) => c.id === cityIdParsed);
    previewCityName = city?.name || null;
  }

  const roleLabel =
    previewRole === "city_admin"
      ? strings("authorities.cityAdmin")
      : previewRole === "whitelabel_admin"
        ? strings("authorities.whitelabelAdmin")
        : strings("authorities.superAdmin");

  return (
    <div className="tw-bg-amber-100 tw-border-b tw-border-amber-200 tw-px-4 tw-py-2 tw-flex tw-items-center tw-justify-between">
      <span className="tw-text-amber-800 tw-text-sm tw-font-medium">
        {strings("settings.previewModeLabel")} {roleLabel}
        {previewWhitelabel &&
          ` @ ${WHITELABEL_LABELS[previewWhitelabel] || previewWhitelabel}`}
        {previewCityName && ` (${previewCityName})`}
      </span>
      <Button
        variant="ghost"
        size="sm"
        onClick={onExit}
        className="tw-text-amber-800 hover:tw-bg-amber-200 hover:tw-text-amber-800"
      >
        {strings("dashboard.exitPreview")}
      </Button>
    </div>
  );
}
